import moment from '@/utils/moment-wrapper';
import * as highcharts from 'highcharts';
import sanitizeHTML from 'sanitize-html';
import { getKey as getSessionDataKey } from '@/data/session/session-globals';

export const $pendo = { moment, highcharts, sanitize: sanitizeHTML };

const pendoGlobalsPlugin = {
    install: (Vue) => {
        Vue.config.globalProperties.$activeUser = getSessionDataKey('activeUser');
        Vue.config.globalProperties.$activeSubscription = getSessionDataKey('activeSubscription');
        Vue.config.globalProperties.$activeOrganization = getSessionDataKey('activeOrganization');
        Vue.config.globalProperties.$activeApplicationMap = getSessionDataKey('activeApplications');

        Vue.prototype.$pendo = $pendo;
    },
};

export default pendoGlobalsPlugin;
